
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsDiscCouponTypeMbDialog extends Serenity.EntityDialog<PsDiscCouponTypeMbRow, any> {
        protected getFormKey() { return PsDiscCouponTypeMbForm.formKey; }
        protected getIdProperty() { return PsDiscCouponTypeMbRow.idProperty; }
        protected getLocalTextPrefix() { return PsDiscCouponTypeMbRow.localTextPrefix; }
        protected getNameProperty() { return PsDiscCouponTypeMbRow.nameProperty; }
        protected getService() { return PsDiscCouponTypeMbService.baseUrl; }
        protected getDeletePermission() { return PsDiscCouponTypeMbRow.deletePermission; }
        protected getInsertPermission() { return PsDiscCouponTypeMbRow.insertPermission; }
        protected getUpdatePermission() { return PsDiscCouponTypeMbRow.updatePermission; }

        protected form = new PsDiscCouponTypeMbForm(this.idPrefix);

    }
}